const isNumeric = (value) => {
  return !isNaN(parseFloat(value)) && isFinite(value)
}
export default isNumeric



// WEBPACK FOOTER //
// ./components/_util/isNumeric.js